module.exports = __webpack_public_path__ + "img/hero-me-trans.d7c1e9b7.png";